<template>
    <div class="image-preview">
        <!-- 工具栏 -->
        <div class="preview-toolbar">
            <a-button size="small" @click="refreshPreview" :loading="loading">
                <ReloadOutlined /> {{ t('common.refreshPreview') }}
            </a-button>
            <span class="image-info" v-if="imageSize.width">
                {{ imageSize.width }} × {{ imageSize.height }}
            </span>
        </div>

        <!-- 预览区域 -->
        <div class="preview-container">
            <a-spin :spinning="loading">
                <div
                    class="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[600px] w-[300px]">
                    <div
                        class="h-[32px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[72px] rounded-s-lg">
                    </div>
                    <div
                        class="h-[46px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[124px] rounded-s-lg">
                    </div>
                    <div
                        class="h-[46px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[178px] rounded-s-lg">
                    </div>
                    <div
                        class="h-[64px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -end-[17px] top-[142px] rounded-e-lg">
                    </div>
                    <div class="rounded-[2rem] overflow-hidden w-[272px] h-[572px] bg-white dark:bg-gray-800">
                        <img v-if="previewUrl" :src="previewUrl" class="preview-image object-cover" alt="Preview" />
                        <a-empty v-else :description="t('common.noPreview')" />
                    </div>
                </div>
            </a-spin>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { ReloadOutlined } from '@ant-design/icons-vue';
import i18n from '@/locales/i18n';

const { t } = i18n.global;
const store = useStore();

const previewUrl = ref('');
const loading = ref(false);
const imageSize = ref({ width: 0, height: 0 });

const appState = computed(() => store.state.app);
const multiState = computed(() => store.state.multi);

// 生成预览图
const generatePreview = () => {
    if (!window.$XJCanvas) {
        previewUrl.value = '';
        imageSize.value = { width: 0, height: 0 };
        return;
    }

    loading.value = true;

    try {
        const { canvasWidth, canvasHeight } = appState.value.editorSize;
        const { left = 0, top = 0, width = canvasWidth, height = canvasHeight } = appState.value.cropInfo;

        const dataUrl = window.$XJCanvas.toDataURL({
            format: 'png',
            quality: 0.8,
            multiplier: 1,
            left,
            top,
            width,
            height,
        });

        previewUrl.value = dataUrl;
        imageSize.value = {
            width: Math.round(width),
            height: Math.round(height)
        };
    } catch (error) {
        console.error('Generate preview error:', error);
        previewUrl.value = '';
        imageSize.value = { width: 0, height: 0 };
    } finally {
        loading.value = false;
    }
};

// 手动刷新预览
const refreshPreview = () => {
    generatePreview();
};

watch(() => multiState.value.requestId, () => {
    if (multiState.value.requestId) {
        setTimeout(() => {
            generatePreview();
        }, 500);
    } else {
        previewUrl.value = '';
        imageSize.value = { width: 0, height: 0 };
    }
});

onMounted(() => {
    if (multiState.value.requestId && window.$XJCanvas) {
        generatePreview();
    }
});
</script>

<style lang="less" scoped>
.image-preview {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 12px;
}

.preview-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e0e0e0;
}

.image-info {
    font-size: 12px;
    color: #666;
}

.preview-container {
    flex: 1;
    display: flex;
    align-items: start;
    justify-content: center;

    overflow: hidden;
    min-height: 200px;

    // background: #f5f5f5;
    // border-radius: 8px;
    // border: 1px solid #e0e0e0;
}

.preview-image {
    // max-width: 100%;
    // max-height: 100%;
    // object-fit: contain;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

:deep(.ant-empty) {
    margin: auto;
}
</style>
